import React from 'react';
import { Link } from 'react-router-dom';
import { getSourceBadge, getDomain } from '../utils/sourceLabels';

// Single evidence row used in the OP card's Supporting Evidence section, in
// expanded ReplyCard evidence panels, and on the incident detail page. Accepts
// either an evidence_checks row OR a sources row (getSourceBadge handles both
// shapes; `evidence_url`/`url` are normalised by getSourceBadge / getDomain).
//
// If postId + ec.id are supplied, the whole row links to the evidence detail
// page. The Link wrapping is only correct for evidence_checks rows — sources
// rows don't currently have a detail route, so callers using sources should
// omit postId (or set ec.id to null).
export default function EvidenceItem({ ec, stopPropagation, postId }) {
  const badge = getSourceBadge(ec);
  const url = ec.evidence_url || ec.url;
  const text = ec.evidence_text || '';
  const inner = (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <span style={{
          fontSize: 10, fontWeight: 600, color: badge.color,
          textTransform: 'uppercase', letterSpacing: '0.05em',
          fontFamily: 'var(--font-body)',
        }}>
          {badge.label}
        </span>
        {url && (
          <span style={{ fontSize: 11, color: '#64748b', fontFamily: 'var(--font-body)' }}>
            🔗 {getDomain(url)}
          </span>
        )}
      </div>
      {text && (
        <div style={{ fontSize: 13, color: '#374151', fontFamily: 'var(--font-body)' }}>
          {text.slice(0, 80)}{text.length > 80 ? '...' : ''}
        </div>
      )}
    </div>
  );
  if (postId && ec.id) {
    return (
      <Link
        to={`/posts/${postId}/evidence/${ec.id}`}
        onClick={stopPropagation ? e => e.stopPropagation() : undefined}
        style={{ textDecoration: 'none', display: 'block' }}
      >
        {inner}
      </Link>
    );
  }
  return inner;
}
